/* esm.sh - unist-util-stringify-position@4.0.0 */
export * from "/*unist-util-stringify-position@4.0.0/esnext/unist-util-stringify-position.mjs";
